import CONSTANTS from 'core/data-model/constants/values'

const { HATS_AND_TAILS, THAI_WIDE_CHARACTER } = CONSTANTS
const ESTIMATED_THAI_CHARACTER_WIDTH = 11
const ESTIMATED_ENGLISH_CHARACTER_WIDTH = 13

export const calculateFontSizeToFitComponent = (text, componentWidth, defaultFontSize, isThaiText) => {
  let fontSize = defaultFontSize
  const estimatedNameWidth = isThaiText ? textWidthThaiWord(text) : textWidthEnglishWord(text)
  if (estimatedNameWidth > componentWidth) {
    let proportion = componentWidth / estimatedNameWidth
    fontSize = proportion * defaultFontSize
  }
  return fontSize
}

export const textWidthThaiWord = (text) => {
  return textWidth(text, ESTIMATED_THAI_CHARACTER_WIDTH)
}

export const textWidthEnglishWord = (text) => {
  return textWidth(text, ESTIMATED_ENGLISH_CHARACTER_WIDTH)
}

const textWidth = (text, characterWidth) => {
  const width = text.split('').reduce((sum, char) => {
    if (HATS_AND_TAILS.indexOf(char) >= 0) return sum

    const w = THAI_WIDE_CHARACTER.indexOf(char) >= 0 ? characterWidth + 1 : characterWidth
    return sum + w
  }, 0)

  return width
}
